var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
import { Container } from '../../layout/Container';
var FooterStyled = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n  min-height: 150px;\n  background-color: ", ";\n  font-size: 1.07rem;\n\n  span {\n    margin: 1.43rem 1.07rem;\n    flex: 1;\n  }\n\n  a {\n    color: #fff;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"], ["\n  width: 100%;\n  min-height: 150px;\n  background-color: ", ";\n  font-size: 1.07rem;\n\n  span {\n    margin: 1.43rem 1.07rem;\n    flex: 1;\n  }\n\n  a {\n    color: #fff;\n    text-decoration: none;\n\n    &:hover {\n      text-decoration: underline;\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.footerBackground;
});
var FooterContainer = styled(Container)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  padding: 0 1.43rem;\n"], ["\n  display: flex;\n  padding: 0 1.43rem;\n"])));
export var FooterLink = styled.a(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: #fff;\n  text-decoration: none;\n  margin-top: 1.43rem;\n"], ["\n  color: #fff;\n  text-decoration: none;\n  margin-top: 1.43rem;\n"])));
export var Footer = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return (<FooterStyled {...props} data-testid="footer">
      <FooterContainer>{children}</FooterContainer>
    </FooterStyled>);
};
var templateObject_1, templateObject_2, templateObject_3;
